
import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import TestDashboard from '@/components/testing/TestDashboard';
import { useIsMobile } from '@/hooks/use-mobile';
import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

const AdminTestDashboard = () => {
  const { user: supabaseUser, profile } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const isMobile = useIsMobile();

  // Check if user is authenticated and has admin access
  const isAuthenticated = !!(supabaseUser || internalUser);
  const userRole = profile?.role || internalUser?.role;
  const hasAdminAccess = userRole === 'admin';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAdminAccess) {
    return (
      <div className="flex flex-col min-h-screen bg-black w-full">
        {!isMobile && <Header />}
        {isMobile && <MobileHeader />}
        
        <main className={`flex-grow flex items-center justify-center ${
          isMobile ? 'mt-16 mb-16' : 'mt-32'
        }`}>
          <Card className="bg-red-900/20 border-red-500 max-w-md">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-red-400">
                <AlertTriangle className="h-5 w-5" />
                Access Denied
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-red-300 mb-4">
                This administrative testing dashboard is restricted to administrator accounts only.
              </p>
              <p className="text-gray-400 text-sm">
                Your current role: {userRole || 'unknown'}
              </p>
            </CardContent>
          </Card>
        </main>
        
        {!isMobile && <Footer />}
        {isMobile && <MobileBottomNav />}
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full px-4 md:px-6 ${
        isMobile 
          ? 'mt-16 mb-16 py-4' 
          : 'mt-24 mb-6 py-6 md:py-12'
      }`}>
        <div className="w-full max-w-7xl mx-auto">
          <TestDashboard />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default AdminTestDashboard;
